import React from 'react';
import PropTypes from 'prop-types';
import { QC_LAYOUT } from '../../constants/reportLayouts';
import ReportLayoutPage from './ReportLayoutPage'


const QCReportLayout = ({ match }) => (
  <ReportLayoutPage
    layout={QC_LAYOUT}
    reportType={match.params.type}
    companyId={match.params.companyId}
    withCoverLetter={false}
    withEndOfReport={true}
    withAttachment={true}
  />
);

QCReportLayout.propTypes = {
  match: PropTypes.object
};

export default QCReportLayout;


// WEBPACK FOOTER //
// src/components/reportLayout/QCReportLayout.jsx